export default {
    NRVU_PATH: "erp/nrvu",
    RVU_PATH: "erp/rvu",
    CURVE_PATH: "curve",
    MAINTENANCE_STATUS_PATH: "status/maintenance"
};